// @flow
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import WorkspaceLink from './WorkspaceLink';
import Members from './Members';
const useStyles = makeStyles((theme) => ({
    navContainer: {
        marginBottom: 20,
    },
}));
const WorkspaceNav = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const links = [
        {
            title: t('workspace.nav.members'),
            to: '/workspace/members',
        },
        {
            disabled: true,
            title: t('workspace.nav.reporting'),
            to: '/workspace/reporting',
        },
        {
            disabled: true,
            title: t('workspace.nav.orgVocabulary'),
            to: '/workspace/org-vocabulary',
        },
        {
            disabled: true,
            title: t('workspace.nav.payment'),
            to: '/workspace/payment',
        },
        {
            disabled: true,
            title: t('workspace.nav.org'),
            to: '/workspace/organization',
        },
    ];
    return (React.createElement("div", null,
        React.createElement("div", { className: classes.navContainer }, links.map((link) => (React.createElement(WorkspaceLink, { key: link.to, link: link })))),
        React.createElement("div", null,
            React.createElement(Route, { path: "/workspace" },
                React.createElement(Switch, null,
                    React.createElement(Route, { path: "/workspace/members", exact: true, component: Members }),
                    React.createElement(Redirect, { to: "/workspace/members" }))))));
};
export default WorkspaceNav;
